/**
 * Wohin ein Klick auf eine Deadline fuehrt (F-09, Leitlinie 5).
 *
 * Aufgaben oeffnen ihren Dialog, Projekte und Ziele fuehren zum
 * hervorgehobenen Eintrag in ihrer Liste, Key Results zu ihrem Ziel.
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { pfad } from '@/app/fokus';
import { useTaskDialog } from '@/modules/tasks/taskDialogStore';
import type { DeadlineItem } from '@/domain/deadlines';

/**
 * Reine Navigation, ohne Dialog - fuer die Gesamtuebersicht, die nur
 * anzeigt (Leitlinie 4). Eine Aufgabe fuehrt zu ihrem Projekt oder Ziel,
 * wo sie mit ihrer Deadline steht, sonst zur Aufgabenliste.
 */
export function deadlinePfad(item: DeadlineItem): string {
  if (item.kind === 'projekt') return pfad.projekt(item.id);
  if (item.kind === 'klausur') return '/schule';
  if (item.kind !== 'aufgabe') return pfad.ziel(item.ownerId);
  if (!item.parent) return '/aufgaben';
  return item.parent.kind === 'projekt' ? pfad.projekt(item.parent.id) : pfad.ziel(item.parent.id);
}

export function useDeadlineOpen(): (item: DeadlineItem) => void {
  const navigate = useNavigate();
  const aufgabeOeffnen = useTaskDialog((s) => s.open);

  return useCallback((item: DeadlineItem) => {
    if (item.kind === 'aufgabe') aufgabeOeffnen(item.id);
    else if (item.kind === 'projekt') navigate(pfad.projekt(item.ownerId));
    else if (item.kind === 'klausur') navigate('/schule');
    else navigate(pfad.ziel(item.ownerId));
  }, [navigate, aufgabeOeffnen]);
}
